<template>
    <div>
        <b-modal v-model="mostrarModal" @show="iniciarForm()">
            <div slot="modal-title">Relação das Etapas</div>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Unidade das Etapas</label>
                        <b-form-select
                            :plain="true"
                            :options="unidades"
                            text-field="unidade"
                            value-field="unidade"
                            v-model="unidade"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="perfil != 'gestor'">
                <b-col sm="12">
                    <b-form-group>
                        <label>Gestor das Etapas</label>
                        <b-form-select
                            :plain="true"
                            :options="gestores"
                            text-field="gestor"
                            value-field="codGestor"
                            v-model="gestor"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label>Início das Etapas (DE)</label>
                        <date-picker
                            v-model="dataInicioDe"
                            :config="$datePickerOptions2"
                            v-mask="'##/##/####'"
                        ></date-picker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label>Início das Etapas (ATÉ)</label>
                        <date-picker
                            v-model="dataInicioAte"
                            :config="$datePickerOptions2"
                            v-mask="'##/##/####'"
                        ></date-picker>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label>Término das Etapas (DE)</label>
                        <date-picker
                            v-model="dataTerminoDe"
                            :config="$datePickerOptions2"
                            v-mask="'##/##/####'"
                        ></date-picker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label>Término das Etapas (ATÉ)</label>
                        <date-picker
                            v-model="dataTerminoAte"
                            :config="$datePickerOptions2"
                            v-mask="'##/##/####'"
                        ></date-picker>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="!formCanceladas">
                <b-col sm="12">
                    <b-form-group>
                        <label>Status das Etapas</label>
                        <b-form-select
                            :plain="true"
                            :options="statusOpc"
                            text-field="status"
                            value-field="status"
                            v-model="status"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="!formCanceladas">
                <b-col sm="12">
                    <b-form-group>
                        <label>Status dos Comprometimentos das Etapas</label>
                        <b-form-select
                            :plain="true"
                            :options="statusComprometimentosOpc"
                            text-field="statusComprometimentoDescr"
                            value-field="statusComprometimento"
                            v-model="statusComprometimento"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fechar()"
                    class="mr-2"
                    >Cancelar</b-button
                >
                <b-button variant="primary" @click.stop="filtrar()"
                    >Emitir Relatório</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { computed } from 'vue'

export default {
    props: {
        servicos: {
            type: Object
        },

        perfil: {
            type: String
        },

        tipo: {
            type: String,
            default: () => 'GERAL'
        }
    },

    data() {
        return {
            mostrarModal: false,
            unidades: [],
            unidade: 'TODAS',
            gestores: [],
            gestor: -1,
            statusComprometimentosOpc: [],
            statusComprometimento: -1,
            statusOpc: [],
            status: 'TODOS',
            dataInicioDe: null,
            dataInicioAte: null,
            dataTerminoDe: null,
            dataTerminoAte: null
        }
    },

    methods: {
        iniciarForm() {
            this.$store.dispatch('addRequest')
            this.servicos.obterOpcoesFiltro().then((response) => {
                if (response) {
                    if (response.success) {
                        this.unidades = response.data.unidades
                        this.unidades.unshift({ unidade: 'TODAS' })
                        if (this.perfil != 'gestor') {
                            this.gestores = response.data.gestores
                            this.gestores.unshift({
                                codGestor: -1,
                                gestor: 'TODOS'
                            })
                        }
                        this.statusComprometimentosOpc =
                            response.data.statusComprometimentosOpc
                        this.statusComprometimentosOpc.unshift({
                            statusComprometimento: -1,
                            statusComprometimentoDescr: 'TODOS'
                        })
                        this.statusOpc = response.data.statusOpc
                        this.statusOpc.unshift({
                            status: 'TODOS',
                            statusDescr: 'TODOS'
                        })
                    } else {
                        this.$toast.error(
                            'Erro ao obter opções dos filtros',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        abrir() {
            this.mostrarModal = true
        },

        fechar() {
            this.mostrarModal = false
        },

        filtrar() {
            let filtroDto = {}
            if (this.unidade != 'TODAS') {
                filtroDto.unidade = this.unidade
            }

            if (this.gestor != -1 && this.perfil != 'gestor') {
                filtroDto.gestor = this.gestor
            }

            if (this.dataInicioDe) {
                filtroDto.dataInicioDe = this.$moment(
                    this.dataInicioDe,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD')
            }

            if (this.dataInicioAte) {
                filtroDto.dataInicioAte = this.$moment(
                    this.dataInicioAte,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD')
            }

            if (this.dataTerminoDe) {
                filtroDto.dataTerminoDe = this.$moment(
                    this.dataTerminoDe,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD')
            }

            if (this.dataTerminoAte) {
                filtroDto.dataTerminoAte = this.$moment(
                    this.dataTerminoAte,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD')
            }

            filtroDto.statusComprometimento = this.statusComprometimento

            if (this.status != 'TODOS') {
                filtroDto.status = this.status
            }

            this.$emit('filtrar', filtroDto)
        }
    },
    
    computed: {
        formCanceladas() {
            if (this.tipo == 'CANCELADAS'){
                return true
            }
            return false
        }
    }
}
</script>
